import React, { useState } from 'react';
import './App.css';
import FormComponent from './components/formv2';
import SuccessScreen from './components/success';
import ErrorScreen from './components/error';

function App() {
  const [page, setPage] = useState("form");

  const queryParams = new URLSearchParams(window.location.search);
  const campaign_name = queryParams.get('utm_campaign') ?? queryParams.get('campaign') ?? '';
  const campaign_details = queryParams.get('utm_content') ?? "";
  const show_how_did_you_hear = queryParams.get('show_hear') === '0' ? false : true;
  const redirect_url = queryParams.get('redirect') ? queryParams.get('redirect') : null;
  const partnership = queryParams.get('utm_partnership') ?? queryParams.get('partnership') ?? "";

  const formMapping = {
    form: <FormComponent
        campaign_details={campaign_details}
        setPage={setPage}
        campaign_name={campaign_name}
        show_how_did_you_hear={show_how_did_you_hear}
        partnership={partnership}
    />,
    success: <SuccessScreen page={page} redirectUrl={redirect_url} />,
    error: <ErrorScreen />
  };

  return (
      <div className="relative min-w-[288px] max-w-[600px] bg-transparent">
        {formMapping[page]}
      </div>
  );
}

export default App;
 